import { Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { ReactElement } from 'react';
import classNames from 'classnames';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    footer: {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[900],
    },
    logo: {
      width: '7rem',
      marginBottom: '.6rem',
    },
  });
});

const Footer = (): ReactElement => {
  const classes = useStyles();

  return (
    <footer className={classNames('pmi-py-4 pmi-px-3', classes.footer)}>
      <div className="pmi-d-flex pmi-justify-content-center">
        <img
          src="/images/logo-cdm-ori.png"
          alt="Logo Comune di Milano"
          className={classNames('pmi-pr-3', classes.logo)}
        />
        <div className="pmi-pl-3">
          <Typography gutterBottom component="address" fontSize="0.7rem" color="primary">
            Comune di Milano, Piazza della Scala, 2 - 20121 Milano Italia
          </Typography>
          <Typography gutterBottom component="div" fontSize="0.7rem" color="primary">
            Codice fiscale/Partita IVA 01199250158
          </Typography>
          <Typography gutterBottom component="div" fontSize="0.7rem" color="primary">
            Centralino unico 020202
          </Typography>
        </div>
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';

export default Footer;
